import Vue from 'vue';
import alert from './alert';

const constructor = Vue.extend(alert);
Vue.prototype.$alertBox = (message, options = {}, confirm = () => {}, cancel = () => {}) => {
	const instance = new constructor({
		data: Object.assign({}, {
			message,
			}, options, {
			confirm,
			cancel
		})
	}).$mount();
	document.body.appendChild(instance.$el);
	Vue.nextTick(() => {
		if(message){
			instance.hidden = false;
		}
	});
	return instance;
}
